import { render, staticRenderFns } from "./Dnaservice.vue?vue&type=template&id=8a3c486a&scoped=true"
import script from "./Dnaservice.vue?vue&type=script&lang=js"
export * from "./Dnaservice.vue?vue&type=script&lang=js"
import style0 from "./Dnaservice.vue?vue&type=style&index=0&id=8a3c486a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a3c486a",
  null
  
)

export default component.exports